import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Funds } from "../../all_Interfaces";
import { getApiCall } from "../../services/apiHelper";
import { InvestmentServiceURL, TaskmgmtServiceURL } from "../../config/config";
import { ServiceName } from "../../constants";


interface InitialState {
    data: Funds[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as Funds[],
    error: '',
    loading: false
}

export const getAllFunds = createAsyncThunk("getAllFunds", async () => {
    try{
        const response = await getApiCall<any>(TaskmgmtServiceURL+"/Funds/getall",ServiceName.TASKMANAGEMENTSERVICE);
        return response.result;
    }catch (error:any) {
        console.error("Error in POST request:", error);
        return error.message;
      }
} );
const allFundsSlice = createSlice({
    name: "allFunds",
    initialState,
    reducers: {},
    extraReducers:(builder) => {
        builder.addCase(getAllFunds.pending,(state) => {
            state.loading = true;
        }).addCase(getAllFunds.fulfilled, (state, action: PayloadAction<Funds[]>) => {
            state.data = action.payload;
            state.loading = false;
            state.error = '';
        }).addCase(getAllFunds.rejected,(state,action)=>{
            state.loading = false;
            state.error = action.error.message || "Something went wrong";
        })
    },
});

export const { } = allFundsSlice.actions;

export default allFundsSlice.reducer;